import { render, staticRenderFns } from "./EditPower.vue?vue&type=template&id=64035f84&scoped=true&"
import script from "./EditPower.vue?vue&type=script&lang=js&"
export * from "./EditPower.vue?vue&type=script&lang=js&"
import style0 from "./EditPower.vue?vue&type=style&index=0&id=64035f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64035f84",
  null
  
)

export default component.exports